import Lottie, { LottieRefCurrentProps } from 'lottie-react'
import { SVGProps, useEffect, useRef } from 'react'

import Logo from './Logo'
import LogoBroken from './LogoBroken'
import LogoFull from './LogoFull'

import loadingAnimation from '@/assets/animations/loading-through.json'
import { cn } from '@repo/ui/lib/utils'

//Static Logo
type FuzeLogoProps = {
  type: 'full' | 'broken' | 'icon'
} & SVGProps<SVGSVGElement>

export function FuzeLogo(props: FuzeLogoProps) {
  if (props.type === 'full') {
    return <LogoFull fill="currentColor" {...props} />
  }
  if (props.type === 'broken') {
    return <LogoBroken fill="currentColor" {...props} />
  }
  return <Logo fill="currentColor" {...props} />
}

//Logo Loader
type FuzeLogoLoaderProps = {
  isLoading: boolean
  className?: string
  logoOnly?: boolean
}

export function FuzeLogoLoader({ isLoading, logoOnly, className }: FuzeLogoLoaderProps) {
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  useEffect(() => {
    if (lottieRef.current) {
      if (isLoading) {
        lottieRef.current.setSpeed(1)
        lottieRef.current.play()
      } else {
        lottieRef.current.setSpeed(2)
      }
    }
  }, [isLoading])

  const handleComplete = () => {
    if (!isLoading && lottieRef.current) {
      lottieRef.current.stop()
    }
  }

  return (
    <div className={cn('text-foreground dark:text-primary relative', className)}>
      <div className="absolute flex h-full items-center justify-center dark:invert">
        <Lottie
          lottieRef={lottieRef}
          animationData={loadingAnimation}
          autoplay={false}
          onLoopComplete={handleComplete}
          className="size-full"
        />
      </div>
      {!logoOnly && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 84 24"
          fill="currentColor"
          className="h-full w-full"
        >
          <path
            shapeRendering="geometricPrecision"
            d="M75.804 22.799c-4.782 0-7.564-3.39-7.564-7.883 0-4.492 2.782-7.883 7.564-7.883 4.753 0 7.535 3.246 7.535 8.23v.87H72.123c.32 2.232 1.594 3.623 3.681 3.623 1.71 0 2.84-.696 3.449-1.942h3.825c-.985 2.985-3.593 4.985-7.274 4.985Zm-3.623-9.39h7.217c-.377-2.058-1.623-3.333-3.594-3.333-2 0-3.246 1.275-3.623 3.333Z"
          />
          <path
            shapeRendering="geometricPrecision"
            d="M68.592 19.38h-7.709l7.796-9.362V7.381H56.217v3.072h7.651l-7.796 9.361v2.637H68.97v-2.43a7.876 7.876 0 0 1-.377-.642ZM45.395 16.307c0 1.74.724 3.072 2.753 3.072 1.391 0 3.304-.898 3.304-3.738V7.38h3.941v15.07h-3.825v-2.057c-1.044 1.39-2.609 2.405-4.753 2.405-3.391 0-5.362-2.26-5.362-6.028v-9.39h3.942v8.926ZM33.065 5.526c0-3.217 1.826-3.941 4.348-3.941h3.361V4.57h-2.347c-1.072 0-1.42.435-1.42 1.362v1.45h3.767v2.984h-3.767v12.085h-3.942V10.366h-2.608V7.381h2.608V5.526Z"
          />
        </svg>
      )}
    </div>
  )
}
